import React from "react";
import appService from "../../../services/app.service";
import { DetailsOverview } from "../base/DetailsOverview";
import { useTranslation } from "react-i18next";
import { NoAdminAlert } from "../../NoAdminAlert"

export const InterviewStatusOverview: React.FunctionComponent<{ isAdmin: boolean }> = (props) => {
    const detailsRedirection = "/config/interviewstatus/details";
    const {t}=useTranslation();
    
    const { isAdmin } = props;
    const title = t("client:headers:tabInterviewStatus");

    if (isAdmin !== true) { return <NoAdminAlert /> }
    
    return (
        <React.Fragment>
            <DetailsOverview detailsRedirection={detailsRedirection} getItems={appService.getInterviewStatus} hasNumber={true}  entityType="interviewstatus" title={title}></DetailsOverview>
        </React.Fragment>
    );
};
